import React from "react";

const RegisterLayout = ({ children }) => {
    return (
        <div className="login-layout flex md:flex-wrap-reverse">{children}</div>
    );
};

export default RegisterLayout;
